module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0001-01.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("NEW YORK, NEW YORK, IT’S A WONDERFUL TOWN")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "paraspaceabove"
  }, [_c('strong', [_c('span', {
    staticClass: "big"
  }, [_vm._v("“L")])]), _vm._v("adies and gentlemen,” the flight attendant announced over the intercom, “we’ve begun our final descent into New York City. Please make sure your seat belts are fastened and your seat backs and tray tables are in the upright and locked position.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look out, New York, Nancy Drew is here. Yes, I mean "), _c('em', [_vm._v("that")]), _vm._v(" Nancy Drew, teen detective and beauty pageant winner!” George Fayne, one of my two closest friends, turned to me from the aisle seat and held an imaginary microphone to her lips. “The-e-e-ere she is, Mi-iss Pretty Face . . . ,” she crooned.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("I groaned. “George, if you sing that to me one ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("more time, I swear I’ll seal your mouth with duct tape.”")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("George smirked. “Goes with the territory, Nan. I know you entered the Miss Pretty Face pageant to solve a mystery, but the mystery’s over now—and yet, here you are, about to take part in the next phase of the competition. I just want to hear you admit that you’re a real pageant girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am not!” I protested. “It just didn’t seem right to drop out, especially after all the drama the pageant has had the last couple of years.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’d originally entered the regional Miss Pretty Face beauty pageant to go undercover. I had been trying to find out why the previous year’s winner had been dethroned. I solved that mystery, and found plenty of scandals and surprises along the way—but the biggest surprise came when I ended up winning the pageant! Now I was on my way to New York City to represent our hometown, River Heights, in the nationwide Miss Pretty Face pageant. George and my other best friend, George’s cousin Bess Marvin, had come with me for moral support (or, in George’s case, to torture me in person) and to take a vacation in the big city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plane’s wheels touched down on the runway and we taxied toward our gate.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“Nancy, can I borrow your Perfect Face again?” Bess asked.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I laughed. “I know you just want to borrow some lotion, but it sounds weird when you put it that way. I feel like saying, ‘My face doesn’t come off!’” Unzipping my carry-on bag, I looked inside for the small Perfect Face Revitalizing Lotion samples I had been given as a contestant. “You can have them all,” I said, handing them to her. “To be honest, I don’t really like the way the lotion makes my face feel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oooh, I do,” Bess said, smoothing it onto her cheeks. “I totally love it! It’s so tingly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s exactly why I don’t like it,” I told her. “I don’t know, it just feels strange.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George put a finger to her lips. “Shhh, don’t say anything bad about the Pretty Face products. Piper’s listening,” she cautioned me. “I bet she’s trying to find some dirt on you so she can get you disqualified as Miss Pretty Face and take your place.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("I sneaked a glance between the seat backs. Sure enough, in the row behind us, the first runner-up, a blond girl named Piper Depken, was leaning forward with her ear cocked. When she caught me looking at her, she flushed and leaned back, giving me a cold stare. “You’ve got bags under ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("your eyes,” she told me, then pointedly held up a magazine and pretended to read it.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I sighed. Talk about a change of attitude. When I first entered the pageant, Piper had been friendly and seemingly helpful, giving me advice about how to make myself a better beauty queen. Granted, her tips included telling me that I was ten pounds overweight and trying to convince me to go on an awful diet in order to lose the weight, but still. However, the moment it had become clear that I was actual competition, the friendly manner had vanished. Piper wanted to win the pageant crown, and she wanted it bad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In fact, I did feel a bit guilty about winning. The crown happened to come with a lot of great stuff, like a scholarship, not to mention free Pretty Face cosmetics for life, since Pretty Face was the pageant’s sponsor. Piper, I knew, came from a poor family and could really have used the scholarship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, and Nancy?” Piper added, tapping my shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned around. “Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That blue top? Wrong color for you,” she said, and gave me a poisonously sweet smile.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("On the other hand, I’d have felt much worse ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("if I’d taken the crown from somebody who was actually "), _c('em', [_vm._v("nice")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_vm._v("After we got off the plane and collected our bags, a sleek black limousine whisked us away toward the Manhattan skyline. Bess, George, Piper, and I shared the big car with Kyle McMahon, the North American brand manager of Pretty Face cosmetics, and his daughter, Kelly, who happened to be the previous year’s Miss Pretty Face River Heights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks for letting George and me share the limo, even though we’re not in the pageant, Mr. McMahon,” Bess gushed. “I feel like a queen, riding into Manhattan this way!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kyle McMahon had been scrolling through the e-mails on his PDA, but now he looked up and gave Bess a smile. “You’re very welcome,” he told her. “It’s bending the rules a bit, but we had the room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His cell phone rang and he answered the call. “Kyle McMahon here. . . . Yes, that’s right. . . . No, that ad campaign rolls out next week. . . . Hang on, I’ve got the e-mail chain right here. . . .”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("As he spoke, he massaged the bridge of his nose wearily. I caught Kelly’s look of concern ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("and gave her a sympathetic smile. “He works pretty hard, doesn’t he?” I whispered.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Especially since he got promoted. He was supposed to spend a week a month in New York City, but he’s been here more like three weeks a month,” Kelly whispered back. She pushed a strand of blond hair off her forehead. “I know I should be happy for him and all, but this new job is really stressing him out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kelly’s mom had passed away when she was ten, and she was an only child, so the bond between her and her dad was pretty tight. I knew what that was like—I lost my mom when I was just a little kid, too—so I completely understood her concern.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Things will settle down after the pageant is over,” I told her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hope so,” she said with a sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We wound through the crooked, tree-lined streets of Greenwich Village and finally pulled up in front of a sleek glass-and-steel building that towered over the surrounding brownstones. A uniformed bellhop came out and opened our car door. “Welcome to the Horatio, ladies,” he said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("“The Horatio Hotel.” Bess sighed in rapture. “I read all about this place in "), _c('em', [_vm._v("Us")]), _vm._v(" magazine. It’s the hottest new spot in the city. I spent a week ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("calling them four times a day until they had a cancellation and I could get a room.” Since she wasn’t with the pageant, Bess had gotten a separate room for George and herself.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wow,” I murmured as I climbed out of the limo. It was certainly a far cry from the chain hotels where beauty pageants were typically held. “I wonder what kind of strings Pretty Face had to pull to get the whole pageant in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kelly overheard me and gave me a slightly forced smile. “My dad is the one who made all the arrangements,” she said. “Don’t tell me you’re thinking of investigating him!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, no,” I assured her quickly. “I didn’t mean anything by it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whoops! Ever since I’d revealed that I was a detective, everyone in the pageant had been treating me a bit warily. It had been especially hard with Kelly because we’d gotten to be such good friends during the River Heights pageant and I think she felt blindsided when she found out I’d been keeping a secret from her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, that’s a relief,” Kelly said with a laugh. We went inside and registered. I saw George’s eyes widen as she looked at the room rates. Bess grinned mischievously. “Hottest spot in the city,” she reminded George.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("“Right,” George said, gulping. “Remind me to point that out to my mom when she sees the bill.”")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Kelly and I followed the bellhop up to the eighth-floor room we were sharing. It was filled with light from a huge window that looked west over the Hudson River. “This is gorgeous!” I said, sinking down on one of the cream-colored armchairs. A low glass coffee table held a bouquet of pink-and-white flowers that filled the air with a delicious scent. I leaned back and stretched out my legs. “Why does traveling make me so tired? It’s not like I did anything but sit all day, but I feel like I could just stay in this armchair forever. That is, if we can get something from room service. I’m starving!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kelly glanced at the pageant agenda that had been left in our room, then at her watch. “Sorry to burst your bubble, but the welcome reception starts in an hour,” she told me. “We’ve just got time to unpack, freshen up, and change.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I got up, sighing. “A pageant girl’s work is never done.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me about it,” Kelly said with a laugh. “You know, I loved being Miss Pretty Face, but I have to say I’m glad it’s your responsibility now. It’s hard to be "), _c('em', [_vm._v("on")]), _vm._v(" all the time. And it’s nice to know I can leave the reception any time I want.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("As I rummaged through my cosmetics bag, I frowned. “Uh-oh. I gave all my Perfect Face samplers to Bess and I forgot to bring a big jar for myself. I’m not being a very good representative of Pretty Face!”")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lucky for you I "), _c('em', [_vm._v("am")]), _vm._v(" a good one,” Kelly joked, and held up her own jar of Perfect Face Revitalizing Lotion. It looked different from mine, as Kelly’s dad was always giving her lab samples rather than the finished product, but I didn’t care. All that mattered was that I show up wearing it. I took it with a smile of thanks and moved into the bathroom to put it on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Bess and George and I were thinking that after the reception we’d go out and see the town,” I called to Kelly. “You want to come with?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a long pause. Then Kelly said, “Um, I’m not sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stuck my head into the bedroom. “What’s up? You’ve got a hot date or something?” I teased.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her cheeks turned pink. “Why would you think that? No, I just don’t know whether I’ll be too tired. It’s been kind of a long day.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("She seemed a little sensitive, so I backed off. “I know what you mean. The way I’m feeling right now, I might come back after the reception ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("too. It "), _c('em', [_vm._v("has")]), _vm._v(" been a long day. And I’ve got a fitness class tomorrow morning.”")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("An hour later the two of us met George and Bess at the elevators. “The reception is in the rooftop ballroom,” Kelly said as we rode up. “It’s supposed to have the most spectacular view of the city and New York Harbor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smoothed the front of my dark blue silk sheath dress. “Do I look okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gorgeous,” Bess told me, licking her finger and smoothing a stray lock of strawberry blond hair back into my up-do. Bess looked stunning as always in a floaty pink dress that set off her big blue eyes and blond hair. George had on a fitted charcoal cocktail dress that showed just how toned and athletic her figure is. She was fiddling with her new digital camcorder, which was tiny and sleek. George is a technology wiz—and a technology freak.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("The elevator doors opened and all four of us gasped at the same moment. The rooftop ballroom "), _c('em', [_vm._v("was")]), _vm._v(" spectacular. It was all decorated in light wood, glass, and brushed steel, with a high ceiling and a giant skylight. Huge picture windows gave views of the city in every direction. Off to the south we could see the Statue of Liberty and the harbor, to the north the Empire State Building, ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("the Brooklyn and Manhattan bridges to the east, and in the west the sun was just starting to set over New Jersey. At one end of the room was a small stage, where a jazz combo played softly.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The room was already crowded with well-dressed people. I spotted Piper by the northern window, wearing a deep red gown and chatting with a tall, willowy, dark-skinned girl who I guessed was one of the other regional Miss Pretty Faces. Kyle McMahon stood by the buffet, a glass in his hand, talking to a huge, muscular man with an iron-gray crew cut who looked as if he should be wearing an army uniform rather than the expensive-looking dark suit he had on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Buffet,” I said, remembering how hungry I was. “I’m there!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Kyle had already spotted Kelly and was hurrying over to us, followed by the guy with the crew cut. “I just called your room and left a message,” he told her. “I was starting to get worried.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I discreetly checked my watch. The reception had started at 7:00. It was now 7:07. And Kelly’s dad was already worrying about her being late? Once again, I thanked my stars that my dad wasn’t crazy overprotective with me like Kyle was with Kelly.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Bess and George moved off as Kyle gestured to the big man at his side. “Ladies, this is Adam Bedrossian, head of security for Pretty Face cosmetics,” he told us. “Adam, this is my daughter, Kelly, the former Miss Pretty Face River Heights, and Nancy Drew, our current Miss Pretty Face.”")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Security?” I repeated, startled. “You mean, like, a bodyguard?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Adam Bedrossian smiled slightly and spoke in a deep, rumbling voice. “Most of the threats I deal with aren’t physical, per se. More along the lines of keeping the corporation and its representatives out of trouble,” he told me. “Although I was a Green Beret. So, Nancy Drew. I’ve heard about you. Heard you uncovered some problems with the River Heights pageant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s me,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His pale eyes, studying me, were cold. “I don’t think you’ll find any problems like that here. But if you do, I hope you’ll bring them to me rather than trying to crack the case on your own.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I bristled a little. Something in the way he spoke was vaguely insulting. Or was I just imagining it? I get a lot of resentment from professionals in law enforcement and detective work because I’m an amateur.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("“Don’t worry,” I said, deciding I was just being ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("oversensitive. “I’m not looking for any new cases. I’m just here to have fun and represent River Heights.”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well-spoken,” Kyle told me with a hearty laugh. “Now, if you’ll excuse us. . . .” Taking Kelly’s arm, he moved off through the crowd, still talking to Adam Bedrossian. Kelly cast me an apologetic look over her shoulder. I smiled and shrugged at her to show I understood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, I could make for the buffet! As I reached it, my stomach gave a loud growl. I glanced around in embarrassment, hoping no one had heard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The petite, dark-haired girl next to me gave me a broad smile. “I know just how you feel,” she said with a slight Spanish accent. “I’ve had my eye on the shrimp cocktail for the past ten minutes. I hope you’re not planning on having any, or I may have to fight you for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I burst out laughing. “Don’t worry, I’ll stay far away from the shrimp,” I promised, helping myself to some cheese and melon slices. “I’m Nancy Drew, by the way. Miss Pretty Face River Heights, believe it or not. Are you one of the contestants?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("The girl almost choked on her shrimp. “Me? Not quite,” she said when she’d recovered. “I’m ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("a biochemist. My name is Anna Chavez.”")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, too bad. I was hoping for someone normal among the other contestants,” I blurted out. Then I felt my cheeks turn bright red. “Oh—I mean . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anna giggled. “I know what you mean. Believe me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I liked Anna already. “I really didn’t mean to offend anyone. It’s just that I still feel a little out of place here. I’m not really a pageant girl, if you want to know the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, that’s why I recognized your name. I heard about you!” Anna said. “You’re that detective who investigated last year’s River Heights pageant, right? Nice job. I’m impressed that you’re a detective—you’re pretty young to be doing work like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was about to say the same thing about you. So what’s it like being a biochemist? And what are you doing here at the Miss Pretty Face reception?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anna dipped a shrimp in cocktail sauce and ate it. “As for why I’m here, I work for Pretty Face here in New York. Research,” she told me. “As for what that’s like . . .” She grinned. “It’s fantastic! I’ve got my dream job!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did you get into it?” I asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Anna shrugged. “Science runs in my family, I suppose. My father was a botanist, back home in Venezuela, where I grew up. He used to take me on nature walks in the jungle all the time. We played a game where I had to identify plants, so I got to know the tropical botanicals quite well.”")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I bet he’s really proud of you now,” I commented.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A shadow crossed her face. “He and my mother passed away when I was seventeen. Car accident.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I bit my lip. “I’m so sorry,” I said. “Both your parents! That must have been hard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was,” she agreed. “I had no other family in Venezuela. Mama was an only child and Papa’s sisters and their families live in England.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So how did you end up here in the U.S.?” I asked. I hoped she didn’t think I was being too nosy. I guess I’m just used to asking a lot of questions—it just goes along with doing detective work.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("“My brother—he’s fifteen years older than me—brought me to live with him, in Texas, where he works as a chemist for one of the oil companies,” Anna explained. She ate another shrimp. “He got me a job working in his company, and I found out I loved chemistry as much as biology. ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("So I went to college and graduate school, and, well . . .” She spread out her hands. “Here I am. Pretty Face uses lots of tropical botanicals in its cosmetic formulas, and I know all about them from my father, so it was a perfect place for me to work.”")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wow!” I said. “That’s an inspiring story.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is?” asked George, who’d just walked up with Bess. She held up her camcorder. “Smile, you two. You’re being immortalized.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I introduced my friends to Anna and explained what she’d just told me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t be a biochemist!” Bess protested. “You’re too young and pretty!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, thank you,” Anna said, her eyes twinkling. “But I assure you, I am older than I look. I work on product development at Pretty Face.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Obviously you’ve been trying out your own products,” Bess said. “Your skin is absolutely flawless! You must use Perfect Face every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anna hesitated. “Actually . . . ,” she began.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But that was as far as she got. Because at that moment all the lights in the room went out. I caught my breath. There were cries of alarm in the dark all around me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A distorted voice shrieked, “The murderers will be exposed!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 78
// module chunks = 0